const createTagScript = (id, src, extraAttributes) => {
  if (!document.querySelector(`script#${id}`)) {
    const script = document.createElement('script')
    script.src = src
    script.id = id
    script.async = true
    script.type = 'text/javascript'

    Object.entries(extraAttributes || {}).forEach(([key, value]) => {
      script.setAttribute(key, value)
    })

    document.head.append(script)
  }
}

export const deleteTagScript = id => {
  const script = document.querySelector(`script#${id}`)
  if (script) document.head.removeChild(script)
}

export const createInlineScript = (id, text) => {
  if (!document.querySelector(`script#${id}`)) {
    const script = document.createElement('script')
    script.id = id
    script.type = 'text/javascript'
    script.text = text

    document.head.append(script)
  }
}

export default createTagScript
